// length
export const inchesToFeet = (x) => x * 0.0833333333333333;
export const inchesToYards = (x) => x * 0.0277777777777778;
export const inchesToMiles = (x) => x * 0.0000157828282828283;
export const inchesToMm = (x) => x * 25.4;
export const inchesToCm = (x) => x * 2.54;
export const inchesToMeters = (x) => x * 0.0254;
export const inchesToKm = (x) => x * 0.0000254;
export const feetToInches = (x) => x * 12;
export const feetToYards = (x) => x * 0.333333333333333;
export const feetToMiles = (x) => x * 0.000189393939393939;
export const feetToMm = (x) => x * 304.8;
export const feetToCm = (x) => x * 30.48;
export const feetToMeters = (x) => x * 0.3048;
export const feetToKm = (x) => x * 0.0003048;
export const yardsToInches = (x) => x * 36;
export const yardsToFeet = (x) => x * 3;
export const yardsToMiles = (x) => x * 0.000568181818181818;
export const yardsToMm = (x) => x * 914.4;
export const yardsToCm = (x) => x * 91.44;
export const yardsToMeters = (x) => x * 0.9144;
export const yardsToKm = (x) => x * 0.0009144;
export const milesToInches = (x) => x * 63360;
export const milesToFeet = (x) => x * 5280;
export const milesToYards = (x) => x * 1760;
export const milesToMm = (x) => x * 1609344;
export const milesToCm = (x) => x * 160934.4;
export const milesToMeters = (x) => x * 1609.344;
export const milesToKm = (x) => x * 1.609344;
export const mmToInches = (x) => x * 0.0393700787401575;
export const mmToFeet = (x) => x * 0.00328083989501312;
export const mmToYards = (x) => x * 0.00109361329833771;
export const mmToMiles = (x) => x * 6.21371192237334e-7;
export const mmToCm = (x) => x * 0.1;
export const mmToMeters = (x) => x * 0.001;
export const mmToKm = (x) => x * 0.000001;
export const cmToInches = (x) => x * 0.393700787401575;
export const cmToFeet = (x) => x * 0.0328083989501312;
export const cmToYards = (x) => x * 0.0109361329833771;
export const cmToMiles = (x) => x * 0.00000621371192237334;
export const cmToMm = (x) => x * 10;
export const cmToMeters = (x) => x * 0.01;
export const cmToKm = (x) => x * 0.00001;
export const metersToInches = (x) => x * 39.3700787401575;
export const metersToFeet = (x) => x * 3.28083989501312;
export const metersToYards = (x) => x * 1.09361329833771;
export const metersToMiles = (x) => x * 0.000621371192237334;
export const metersToMm = (x) => x * 1000;
export const metersToCm = (x) => x * 100;
export const metersToKm = (x) => x * 0.001;
export const kmToInches = (x) => x * 39370.0787401575;
export const kmToFeet = (x) => x * 3280.83989501312;
export const kmToYards = (x) => x * 1093.61329833771;
export const kmToMiles = (x) => x * 0.621371192237334;
export const kmToMm = (x) => x * 1000000;
export const kmToCm = (x) => x * 100000;
export const kmToMeters = (x) => x * 1000;

// area
export const in2ToFt2 = (x) => x * 0.00694444444444444;
export const in2ToM2 = (x) => x * 0.00064516;
export const ft2ToIn2 = (x) => x * 144;
export const ft2ToM2 = (x) => x * 0.09290304;
export const m2ToIn2 = (x) => x * 1550.0031000062;
export const m2ToFt2 = (x) => x * 10.7639104167097;

// volume
export const in3ToFt3 = (x) => x * 0.000578703703703704;
export const in3ToM3 = (x) => x * 0.000016387064;
export const in3ToLiters = (x) => x * 0.016387064;
export const in3ToGalUs = (x) => x * 0.00432900432900433;
export const ft3ToIn3 = (x) => x * 1728;
export const ft3ToM3 = (x) => x * 0.028316846592;
export const ft3ToLiters = (x) => x * 28.316846592;
export const ft3ToGalUs = (x) => x * 7.48051948051948;
export const m3ToIn3 = (x) => x * 61023.7440947323;
export const m3ToFt3 = (x) => x * 35.3146667214886;
export const m3ToLiters = (x) => x * 1000;
export const m3ToGalUs = (x) => x * 264.172052358148;
export const litersToIn3 = (x) => x * 61.0237440947323;
export const litersToFt3 = (x) => x * 0.0353146667214886;
export const litersToM3 = (x) => x * 0.001;
export const litersToGalUs = (x) => x * 0.264172052358148;
export const galUsToIn3 = (x) => x * 231;
export const galUsToFt3 = (x) => x * 0.133680555555556;
export const galUsToM3 = (x) => x * 0.003785411784;
export const galUsToLiters = (x) => x * 3.785411784;

// mass
export const grainsToOunces = (x) => x * 0.00228571428571429;
export const grainsToLb = (x) => x * 0.000142857142857143;
export const grainsToGrams = (x) => x * 0.06479891;
export const grainsToKg = (x) => x * 0.00006479891;
export const ouncesToGrains = (x) => x * 437.5;
export const ouncesToLb = (x) => x * 0.0625;
export const ouncesToGrams = (x) => x * 28.349523125;
export const ouncesToKg = (x) => x * 0.028349523125;
export const lbToGrains = (x) => x * 7000;
export const lbToOunces = (x) => x * 16;
export const lbToGrams = (x) => x * 453.59237;
export const lbToKg = (x) => x * 0.45359237;
export const gramsToGrains = (x) => x * 15.4323583529414;
export const gramsToOunces = (x) => x * 0.0352739619495804;
export const gramsToLb = (x) => x * 0.00220462262184878;
export const gramsToKg = (x) => x * 0.001;
export const kgToGrains = (x) => x * 15432.3583529414;
export const kgToOunces = (x) => x * 35.2739619495804;
export const kgToLb = (x) => x * 2.20462262184878;
export const kgToGrams = (x) => x * 1000;

// speed
export const fpsToMps = (x) => x * 0.3048;
export const fpsToMph = (x) => x * 0.681818181818182;
export const fpsToKmh = (x) => x * 1.09728;
export const mpsToFps = (x) => x * 3.28083989501312;
export const mpsToMph = (x) => x * 2.2369362920544;
export const mpsToKmh = (x) => x * 3.6;
export const mphToFps = (x) => x * 1.46666666666667;
export const mphToMps = (x) => x * 0.44704;
export const mphToKmh = (x) => x * 1.609344;
export const kmhToFps = (x) => x * 0.911344415281423;
export const kmhToMps = (x) => x * 0.277777777777778;
export const kmhToMph = (x) => x * 0.621371192237334;

// momentOfInertia
export const gcm2ToKgm2 = (x) => x * 1.00000000000000e-7;
export const gcm2ToLbin2 = (x) => x * 0.00034171718982094;
export const gcm2ToLbft2 = (x) => x * 0.00000237303604042319;
export const kgm2ToGcm2 = (x) => x * 10000000;
export const kgm2ToLbin2 = (x) => x * 3417.1718982094;
export const kgm2ToLbft2 = (x) => x * 23.7303604042319;
export const lbin2ToGcm2 = (x) => x * 2926.396534292;
export const lbin2ToKgm2 = (x) => x * 0.0002926396534292;
export const lbin2ToLbft2 = (x) => x * 0.00694444444444444;
export const lbft2ToGcm2 = (x) => x * 421401.100938048;
export const lbft2ToKgm2 = (x) => x * 0.0421401100938048;
export const lbft2ToLbin2 = (x) => x * 144;

// pressure
export const paToKpa = (x) => x * 0.001;
export const paToMpa = (x) => x * 0.000001;
export const paToBar = (x) => x * 0.00001;
export const paToAtm = (x) => x * 0.00000986923266716013;
export const paToPsi = (x) => x * 0.000145037737738703;
export const paToMmhg = (x) => x * 0.00750063755419211;
export const kpaToPa = (x) => x * 1000;
export const kpaToMpa = (x) => x * 0.001;
export const kpaToBar = (x) => x * 0.01;
export const kpaToAtm = (x) => x * 0.00986923266716013;
export const kpaToPsi = (x) => x * 0.145037737738703;
export const kpaToMmhg = (x) => x * 7.50063755419211;
export const mpaToPa = (x) => x * 1000000;
export const mpaToKpa = (x) => x * 1000;
export const mpaToBar = (x) => x * 10;
export const mpaToAtm = (x) => x * 9.86923266716013;
export const mpaToPsi = (x) => x * 145.037737738703;
export const mpaToMmhg = (x) => x * 7500.63755419211;
export const barToPa = (x) => x * 100000;
export const barToKpa = (x) => x * 100;
export const barToMpa = (x) => x * 0.1;
export const barToAtm = (x) => x * 0.986923266716013;
export const barToPsi = (x) => x * 14.5037737738703;
export const barToMmhg = (x) => x * 750.063755419211;
export const atmToPa = (x) => x * 101325;
export const atmToKpa = (x) => x * 101.325;
export const atmToMpa = (x) => x * 0.101325;
export const atmToBar = (x) => x * 1.01325;
export const atmToPsi = (x) => x * 14.6959487763741;
export const atmToMmhg = (x) => x * 760.002100178515;
export const psiToPa = (x) => x * 6894.75729276459;
export const psiToKpa = (x) => x * 6.89475729276459;
export const psiToMpa = (x) => x * 0.00689475729276459;
export const psiToBar = (x) => x * 0.0689475729276459;
export const psiToAtm = (x) => x * 0.0680459639058928;
export const psiToMmhg = (x) => x * 51.71507547715;
export const mmhgToPa = (x) => x * 133.322;
export const mmhgToKpa = (x) => x * 0.133322;
export const mmhgToMpa = (x) => x * 0.000133322;
export const mmhgToBar = (x) => x * 0.00133322;
export const mmhgToAtm = (x) => x * 0.00131578583765112;
export const mmhgToPsi = (x) => x * 0.0193367212707994;
export const inhgToPa = (x) => x * 3386.39;

// density
export const kgm3ToGcm3 = (x) => x * 0.001;
export const kgm3ToLbft3 = (x) => x * 0.0624279605761446;
export const kgm3ToLbgalUs = (x) => x * 0.00834540445201933;
export const gcm3ToKgm3 = (x) => x * 1000;
export const gcm3ToLbft3 = (x) => x * 62.4279605761446;
export const gcm3ToLbgalUs = (x) => x * 8.34540445201933;
export const lbft3ToKgm3 = (x) => x * 16.0184633739601;
export const lbft3ToGcm3 = (x) => x * 0.0160184633739601;
export const lbft3ToLbgalUs = (x) => x * 0.133680555555556;
export const lbgalUsToKgm3 = (x) => x * 119.826427316897;
export const lbgalUsToGcm3 = (x) => x * 0.119826427316897;
export const lbgalUsToLbft3 = (x) => x * 7.48051948051948;

// energy
export const jouleToKJ = (x) => x * 0.001;
export const jouleToMJ = (x) => x * 0.000001;
export const jouleToBtu = (x) => x * 0.000947817120313317;
export const jouleToKwh = (x) => x * 2.77777777777778e-7;
export const jouleToFtlb = (x) => x * 0.737562149277265;
export const kJToJoule = (x) => x * 1000;
export const kJToMJ = (x) => x * 0.001;
export const kJToBtu = (x) => x * 0.947817120313317;
export const kJToKwh = (x) => x * 0.000277777777777778;
export const kJToFtlb = (x) => x * 737.562149277265;
export const mJToJoule = (x) => x * 1000000;
export const mJToKJ = (x) => x * 1000;
export const mJToBtu = (x) => x * 947.817120313317;
export const mJToKwh = (x) => x * 0.277777777777778;
export const mJToFtlb = (x) => x * 737562.149277265;
export const btuToJoule = (x) => x * 1055.05585262;
export const btuToKJ = (x) => x * 1.05505585262;
export const btuToMJ = (x) => x * 0.00105505585262;
export const btuToKwh = (x) => x * 0.000293071070172222;
export const btuToFtlb = (x) => x * 778.169262265965;
export const kwhToJoule = (x) => x * 3600000;
export const kwhToKJ = (x) => x * 3600;
export const kwhToMJ = (x) => x * 3.6;
export const kwhToBtu = (x) => x * 3412.14163312794;
export const kwhToFtlb = (x) => x * 2655223.73739816;
export const ftlbToJoule = (x) => x * 1.3558179483314;
export const ftlbToKJ = (x) => x * 0.0013558179483314;
export const ftlbToMJ = (x) => x * 0.0000013558179483314;
export const ftlbToBtu = (x) => x * 0.00128506746345658;
export const ftlbToKwh = (x) => x * 3.76616096758722e-7;

// power
export const wattToKW = (x) => x * 0.001;
export const wattToMW = (x) => x * 0.000001;
export const wattToHp = (x) => x * 0.00134102208967356;
export const kWToWatt = (x) => x * 1000;
export const kWToMW = (x) => x * 0.001;
export const kWToHp = (x) => x * 1.34102208967356;
export const mWToWatt = (x) => x * 1000000;
export const mWToKW = (x) => x * 1000;
export const mWToHp = (x) => x * 1341.02208967356;
export const hpToWatt = (x) => x * 745.6998715386;
export const hpToKW = (x) => x * 0.7456998715386;
export const hpToMW = (x) => x * 0.0007456998715386;

// torque
export const nmToLbft = (x) => x * 0.737562149277265;
export const lbftToNm = (x) => x * 1.3558179483314;

// angle
export const degToRad = (x) => x * 0.0174532925199433;
export const radToDeg = (x) => x * 57.2957795130823;

// temperature
export const cToF = x => (x * 9/5) + 32;
export const fToC = x => (x - 32) * 5/9;
export const cToK = x => x + 273.15;
export const kToC = x => x - 273.15;
export const fToK = x => (x - 32) * 5/9 + 273.15;
export const kToF = x => (x - 273.15) * 9/5 + 32;
